<template>
    <section
        class="pricing section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                id="plans"
                class="pricing-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content" />
                <div
                    class="tiles-wrap has-bg-color illustration-section-05"
                    :class="[
                        pushLeft && 'push-left',
                    ]">
                    <div class="tiles-item reveal-scale-down">
                        <div style="border: 4px solid #eee; border-radius: 4px" class="tiles-item-inner has-shadow">
                            <div class="pricing-item-content">
                                <div class="pricing-item-header mb-24">
                                    <div class="pricing-item-title text-xs text-color-high fw-500 pb-4">
                                        Free
                                    </div>
                                    <div class="pricing-item-price">
                                        <span class="pricing-item-price-currency h2">{{ getPricingData(this.priceOutput.plan1, 0) }}</span>
                                        <span class="pricing-item-price-amount h1">{{ getPricingData(this.priceOutput.plan1, 1) }}</span>
                                    </div>
                                    <div class="text-color-low text-xs">
                                        with watermarks after a few days
                                    </div>
                                </div>
                                <div class="pricing-item-features mb-40">
                                    <div class="pricing-item-features-title text-xs fw-500 text-color-high mb-24">
                                        What’s included
                                    </div>
                                    <ul class="pricing-item-features-list list-reset text-xs mb-32">
                                        <li class="is-checked">For personal use on 1 device</li>
                                        <li class="is-checked">Software upgrades</li>
                                        <li>No watermarks</li>
                                        <li>Multi-year subscriptions</li>
                                        <li>Large team discounts</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pricing-item-cta mb-8">
                                <c-button @click="openEmailModal" color="primary" wide href="#">Free 14-day trial</c-button>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-down" data-reveal-delay="100">
                        <div style="border: 4px solid #e45a27; border-radius: 4px" class="tiles-item-inner has-shadow">
                            <div style="position: absolute; right: -1px; justify-content: center; text-align: center; top: -1px; width: 144px; height: 35px; border-radius: 0 0 0 4px; background-color: #e45a27">
                                <span class="text-xs fw-700 ml-4" style="color: white;">Most popular</span>
                            </div> 
                            <div class="pricing-item-content">
                                <div class="pricing-item-header mb-24">
                                    <div class="pricing-item-title text-xs text-color-high fw-500 pb-4">
                                        Personal
                                    </div>
                                    <div class="pricing-item-price">
                                        <span class="pricing-item-price-currency h2">{{ getPricingData(this.priceOutput.plan2, 0) }}</span>
                                        <span class="pricing-item-price-amount h1">{{ getPricingData(this.priceOutput.plan2, 1) }}</span>
                                    </div>
                                    <div class="text-color-low text-xs">
                                        /per user, per <b>year</b>
                                    </div>
                                </div>
                                <div class="pricing-item-features mb-40">
                                    <div class="pricing-item-features-title text-xs fw-500 text-color-high mb-24">
                                        What’s included
                                    </div>
                                    <ul class="pricing-item-features-list list-reset text-xs mb-32">
                                        <li class="is-checked">For personal use on 2 devices</li>
                                        <li class="is-checked">Software upgrades & support</li>
                                        <li class="is-checked">No watermarks</li>
                                        <li class="is-checked">Multi-year subscriptions</li>
                                        <li>Large team discounts</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pricing-item-cta mb-8">
                                <c-button tag="button" color="primary" wide @click="openPersonalBuyPage">Buy now</c-button>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-down" data-reveal-delay="200">
                        <div style="border: 4px solid #eee; border-radius: 4px" class="tiles-item-inner has-shadow">
                            <div class="pricing-item-content">
                                <div class="pricing-item-header mb-24">
                                    <div class="pricing-item-title text-xs text-color-high fw-500 pb-4">
                                        Business
                                    </div>
                                    <div class="pricing-item-price">
                                        <span class="pricing-item-price-currency h2">{{ getPricingData(this.priceOutput.plan3, 0) }}</span>
                                        <span class="pricing-item-price-amount h1">{{ getPricingData(this.priceOutput.plan3, 1) }}</span>
                                    </div>
                                    <div class="text-color-low text-xs">
                                        /per user, per <b>year</b>
                                    </div>
                                </div>
                                <div class="pricing-item-features mb-40">
                                    <div class="pricing-item-features-title text-xs fw-500 text-color-high mb-24">
                                        What’s included
                                    </div>
                                    <ul class="pricing-item-features-list list-reset text-xs mb-32">
                                        <li class="is-checked">For business use on 2 devices</li>
                                        <li class="is-checked">Software upgrades & support</li>
                                        <li class="is-checked">No watermarks</li>
                                        <li class="is-checked">Multi-year subscriptions</li>
                                        <li class="is-checked">Large team discounts</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pricing-item-cta mb-8">
                                <c-button tag="button" color="primary" wide @click="openBusinessBuyPage">Buy now</c-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CSwitch from '@/components/elements/Switch.vue'
import CButton from '@/components/elements/Button.vue'
import CModal from '@/components/elements/Modal.vue'

import axios from 'axios'

export default {
  name: 'CPricing',
  components: {
    CSectionHeader,
    CSwitch,
    CButton,
    CModal
  },
  mixins: [SectionTilesProps],
  props: {
    pricingSwitcher: {
      type: Boolean,
      default: false
    },
    pricingSlider: {
      type: Boolean,
      default: false
    }        
  },
  data() {
    return {
      sectionHeader: {
        title: 'Easy pricing',
        paragraph: 'Free forever with minimal watermarks, or purchase now to get full access to Pixtel for as low as $25 a year.'
      },
      priceChangerValue: "1",
      priceInput: {
        // 0: "1,000",
        // 1: "1,250"
      },
      priceOutput: {
        plan1: {
          0: ["$", "0", ""],
          1: ["$", "0", ""]
        },
        plan2: {
          0: ["$", "25", "annually"],
          1: ["$", "25", "annually"]
        },
        plan3: {
          0: ["$", "50", "annually"],
          1: ["$", "50", "annually"]
        }
      }
    }
  },
  methods: {    
    openEmailModal() {
        document.getElementById("download").click();
    },
    openPersonalBuyPage() {
        window.open("https://getpixit.onfastspring.com/", "_blank");
    },
    openBusinessBuyPage() {
        window.open("https://getpixit.onfastspring.com/", "_blank");
    },
    handlePricingSlide(e) {
      this.handleSliderValuePosition(e.target)
    },
    handleSliderValuePosition(input) {
      const multiplier = input.value / input.max
      const thumbOffset = this.thumbSize * multiplier
      const priceInputOffset = (this.thumbSize - this.$refs.sliderValue.clientWidth) / 2
      this.$refs.sliderValue.style.left = input.clientWidth * multiplier - thumbOffset + priceInputOffset + 'px'
    },
    getPricingData(values, set) {
      return set !== undefined ? values[this.priceChangerValue][set] : values[this.priceChangerValue]
    }
  },
  mounted() {
    if (this.pricingSlider) {
      this.$refs.slider.setAttribute('min', 0)
      this.$refs.slider.setAttribute('max', Object.keys(this.priceInput).length - 1)
      this.thumbSize = parseInt(window.getComputedStyle(this.$refs.sliderValue).getPropertyValue('--thumb-size'), 10)
      this.handleSliderValuePosition(this.$refs.slider)
    }        
  }
}
</script>